import { Quaternion, Vector3 } from 'three'
import type { RNGConfig } from '../../core/rng/RNGConfig.type'
import { next } from '../../core/rng/index'
import { TWO_PI } from '../../core/util/math/Math'

/**
 * Creates a random quaternion rotation around the Y-axis only
 * @param rng - Random number generator configuration
 * @param q - Quaternion to set the rotation to
 * @param minAngle - Minimum angle in radians (default: 0)
 * @param maxAngle - Maximum angle in radians (default: 2π)
 */
export default function setRandomYRotationQuaternion(
  rng: RNGConfig, 
  q: Quaternion, 
  minAngle: number = 0, 
  maxAngle: number = TWO_PI
): void {
  const angle = minAngle + next(rng) * (maxAngle - minAngle);
  q.setFromAxisAngle(new Vector3(0, 1, 0), angle);
}
